<script>
import * as moment from 'moment';
import AuditRecordsListGroup from '@/dataAdmin/components/AuditRecordsListGroup.vue';

export default {
  components: {
    AuditRecordsListGroup,
  },

  data: function () {
    let numDaysInPast = 2;
    return {
      fromDate: moment().add(-numDaysInPast, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
    }
  },
}
</script>

<template>
  <div>

    <b-card class="mb-3">
      <div class="h5 text-center m-0">
        Audit Records
      </div>

      <div class="row my-2">
        <div class="col-6 offset-md-2 col-md-4">
          <b-form-input :id="`from-${_uid}`" v-model="fromDate" type="date" size="sm"></b-form-input>
        </div>
        <div class="col-6 col-md-4">
          <b-form-input :id="`to-${_uid}`" v-model="toDate" type="date" size="sm"></b-form-input>
        </div>
      </div>
    </b-card>

    <api-loader
      :key="`${encodeURIComponent(fromDate)}/${encodeURIComponent(toDate)}`"
      method="get"
      :url="`v1/dataAdmin/audit-records/${encodeURIComponent(fromDate)}/${encodeURIComponent(toDate)}`">

      <div slot-scope="{busy, error, result}" v-if="!busy">

        <b-card v-if="result&&result.length>0">
          <audit-records-list-group :records="result" />
        </b-card>
        <b-card v-else>
          <div class="text-muted">No audit records in this date range</div>
        </b-card>

      </div>
    </api-loader>

  </div>
</template>



// WEBPACK FOOTER //
// src/dataAdmin/views/AuditRecordsView.vue